import { createPortal } from "react-dom";
import { CheckCircle2, Info, XCircle, X } from "lucide-react";
import { useToastStore, type ToastTone } from "@/store/toast.store";
import { cn } from "@/utils/cn";

const toneStyles: Record<ToastTone, string> = {
  success: "border-teal-500/40 bg-teal-50 text-teal-700",
  error: "border-danger-500/40 bg-danger-50 text-danger-600",
  info: "border-border bg-cream-50 text-ink",
};

const toneIcons: Record<ToastTone, React.ReactNode> = {
  success: <CheckCircle2 className="h-4 w-4" />,
  error: <XCircle className="h-4 w-4" />,
  info: <Info className="h-4 w-4" />,
};

/** Renders all active toasts. Mounted once, at the app root (see app/providers). */
export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return createPortal(
    <div className="fixed bottom-4 right-4 z-[100] flex w-80 flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            "flex items-start gap-2 rounded-lg border px-3 py-2.5 text-sm shadow-popover",
            toneStyles[t.tone],
          )}
        >
          {toneIcons[t.tone]}
          <p className="flex-1">{t.message}</p>
          <button onClick={() => dismiss(t.id)} aria-label="Dismiss">
            <X className="h-3.5 w-3.5 opacity-60" />
          </button>
        </div>
      ))}
    </div>,
    document.body,
  );
}
